//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

/* Const */
const SELECTOR_DATA_ELEMENT$1 = '.restMenus_prod-pricelist .restMenus_prod-price';
const PRICE_ATTRIBUTE$1 = '.00';

//header image to be window height on homepage
resizeWindow();


// Func = limiting Scope for this file
(function(){

	//tablet menu
	if(document.getElementById('tabletBurger')){
		document.getElementById('tabletBurger').addEventListener('click', function(){
			if(!document.getElementById('primary-nav').classList.contains('open')){
				document.getElementById('primary-nav').classList.add('open');
				this.classList.add('open')
			} else {
				document.getElementById('primary-nav').classList.remove('open');
				this.classList.remove('open')
			}
		});
	}

	//mobile menu
	if(document.getElementById('burgerMenu')){
		document.getElementById('burgerMenu').addEventListener('click', function(){
			if(!document.getElementById('primary-nav').classList.contains('open')){
				document.getElementById('primary-nav').classList.add('open');
				//this.classList.add('open')
				document.getElementById('closeMenu').classList.add('active');
				document.getElementById('header-contact').classList.add('open');
			} else {
				document.getElementById('primary-nav').classList.remove('open');
				//this.classList.remove('open')
				document.getElementById('closeMenu').classList.remove('active');
				document.getElementById('header-contact').classList.remove('open');
			}
		});
	}
	document.getElementById('closeMenu').addEventListener('click', function(){
		document.getElementById('primary-nav').classList.remove('open');
		document.getElementById('header-contact').classList.remove('open');
		this.classList.remove('active');
		//document.getElementById('burgerMenu').classList.remove('active')
	});

	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		//outside click
		let alllightbox = document.getElementsByClassName('lightbox');
		let alllightLength = alllightbox.length;
		for(let j = 0; j < alllightLength; j++ ){
			alllightbox[j].addEventListener('click', function(){
				if(this.classList.contains('open')){
					this.classList.remove('open')
				}
			});
		}
	}
	
	window.onload = function() {
		if(document.getElementById('home')){
			if(windowWidth > 600){
				scrollW();
				window.addEventListener('scroll', function(){
					scrollW();
				})
			} else {
				document.getElementById('header').classList.add('down');
				window.addEventListener('scroll', function(){
					scrollMobile();
				})
			}
		} else {
			document.getElementById('header').classList.add('down');
		}
		resizeWindow();
		window.addEventListener('resize', function(){
			resizeWindow();
		});
	};

	
	// RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > (windowHeight * 0.70)){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
			
			document.getElementsByClassName('bottom-nav')[0].classList.add('down');
			document.getElementsByClassName('bottom-nav')[0].classList.remove('up');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function scrollMobile(){
	var stm = window.pageYOffset || document.documentElement.scrollTop;
		
		if(stm > 5){
			if (stm > lastScrollTop){
				// downscroll code
				if(!document.getElementsByClassName('bottom-nav')[0].classList.contains('down')){
					document.getElementsByClassName('bottom-nav')[0].classList.add('down');
					document.getElementsByClassName('bottom-nav')[0].classList.remove('up');
					
				}
			} else {
				// upscroll code
				if(!document.getElementsByClassName('bottom-nav')[0].classList.contains('up')){
					document.getElementsByClassName('bottom-nav')[0].classList.remove('down');
					document.getElementsByClassName('bottom-nav')[0].classList.add('up');
					
				}
			}
		} else {
			if(document.getElementsByClassName('bottom-nav')[0].classList.contains('up') || document.getElementsByClassName('bottom-nav')[0].classList.contains('down')){
				document.getElementsByClassName('bottom-nav')[0].classList.remove('down');
				document.getElementsByClassName('bottom-nav')[0].classList.remove('up');

				
			}
		}
		lastScrollTop = stm <= 0 ? 0 : stm; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	
	if(document.getElementsByClassName('big-image').length > 0){
		
		let headerImages = document.getElementsByClassName('big-image');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			if(document.getElementById('home')){
				headerImages[i].style.height = (windowHeight + 5) + 'px';
			} else {
				headerImages[i].style.height = '420px';
			}
		}
		
	}
	
	if(windowWidth < 600){
		if(document.getElementById('home')){

		}
	}
	if(windowWidth < 1000){
		document.getElementById('primary-nav').classList.add('tablet-view');
	}
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

const disableOption = document.getElementById("id_6_496");

if(disableOption){
	disableOption.options[0].innerHTML = "";
}


/**
 * formatPricing -  Format price to current money
 */
function formatPricing() {
	let prices = document.querySelectorAll(SELECTOR_DATA_ELEMENT$1);

	/* 
		const formatMoney = new Intl.NumberFormat(Country, {
			style: "currency",
			currency: Currency,
			minimumFractionDigits: 2,
		});

		return formatMoney.format(Price)
	*/

	prices.forEach(function (price) {
		let priceText = price.innerText;
		price.innerText = priceText.replaceAll(PRICE_ATTRIBUTE$1, '');
	})
}

formatPricing();